import React from "react";
import { useFeatures } from "../hooks/usePermissions";
import NoAccess from "./NoAccess";
import config from "../config";

// Route guard: renders children only if the organization's plan includes
// `feature`. Like RequirePermission it keeps the person inside the shell and
// explains, rather than redirecting out. The proxy enforces the same key on the
// API, so this is UX, not the trust boundary.
export default function RequireFeature({ feature, children }) {
  const { has, loading } = useFeatures();
  if (loading) return null;
  if (!has(feature)) {
    return (
      <NoAccess
        message={`This module isn't included in your organization's EcoPrism plan. Ask your EcoPrism administrator, or contact ${config.supportEmail} to add it.`}
      />
    );
  }
  return children;
}
